const isIOS = /iPhone|iPad/i.test(navigator.userAgent)

export default isIOS
